import { BudgetCategory } from "./types";
import { getBudgetTotalEstimate } from "./BudgetItemUtils";

export interface BudgetRerunSnapshot {
  capturedAt: string;
  grandTotal: number;
  categories: BudgetCategory[];
}

function snapshotStorageKey(projectId: string | number, documentId: string | number): string {
  return `rivetai:budget-rerun-snapshot:${projectId}:${documentId}`;
}

export function saveBudgetRerunSnapshot(
  projectId: string | number,
  documentId: string | number,
  categories: BudgetCategory[],
  contingency: {
    contingency_percentage: number;
    locked: boolean;
    actual_amount: number | null;
  }
): void {
  const snapshot: BudgetRerunSnapshot = {
    capturedAt: new Date().toISOString(),
    grandTotal: getBudgetTotalEstimate(categories, contingency),
    categories,
  };
  localStorage.setItem(snapshotStorageKey(projectId, documentId), JSON.stringify(snapshot));
}

export function readBudgetRerunSnapshot(
  projectId: string | number,
  documentId: string | number
): BudgetRerunSnapshot | null {
  const raw = localStorage.getItem(snapshotStorageKey(projectId, documentId));
  if (!raw) return null;
  try {
    return JSON.parse(raw) as BudgetRerunSnapshot;
  } catch {
    return null;
  }
}

export function clearBudgetRerunSnapshot(
  projectId: string | number,
  documentId: string | number
): void {
  localStorage.removeItem(snapshotStorageKey(projectId, documentId));
}

export interface BudgetRerunDiffLine {
  categoryName: string;
  before: number;
  after: number;
  delta: number;
}

export function buildBudgetRerunDiff(
  beforeCategories: BudgetCategory[],
  afterCategories: BudgetCategory[]
): BudgetRerunDiffLine[] {
  const beforeMap = new Map(
    beforeCategories.map((category) => [
      category.budget_category_id,
      getBudgetTotalEstimate([category], null),
    ])
  );

  return afterCategories.map((category) => {
    const before = beforeMap.get(category.budget_category_id) ?? 0;
    const after = getBudgetTotalEstimate([category], null);
    return {
      categoryName: category.name,
      before,
      after,
      delta: after - before,
    };
  });
}
